import type { ActiveGameDataSAG } from '@ps/web-poker-types';
import type React from 'react';

import styles from './shared.module.scss';

interface Props {
  game: ActiveGameDataSAG;
}

const GameItemInfoSAG: React.FC<Props> = ({ game }) => (
  <>
    <span>{game.gameVariant}</span>
    <span className={styles.separator}>&nbsp;|&nbsp;</span>
    <span>{game.name}</span>
  </>
);

export default GameItemInfoSAG;
